import { MouseEvent, ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTornaIndietro } from "../../hooks/useStatoUrl";

/**
 * Link "← Sezione" in testa a una scheda di dettaglio.
 *
 * Resta un vero link verso la rotta padre (si apre in una nuova scheda con il
 * tasto centrale o Ctrl+clic, e l'indirizzo si vede passandoci sopra), ma il
 * clic normale passa da `useTornaIndietro`: se la pagina precedente è proprio
 * la rotta padre si torna indietro, ritrovando filtri, ricerca e scroll.
 */
export function LinkIndietro({ to, className, children }: { to: string; className?: string; children: ReactNode }) {
  const torna = useTornaIndietro();

  function handleClick(e: MouseEvent<HTMLAnchorElement>) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    torna(to);
  }

  return (
    <Link to={to} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
}
